import { Injectable } from '@angular/core';
import { ReviewForm } from '../../shared/models/review-form/review-form.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ReviewFormService {
  private baseUrl = environment.baseUrl + 'v2.0/projects/review/form/';

  constructor(private http: HttpClient) { }

  public getReview = (pprId: string) => this.http.get<ReviewForm>(`${this.baseUrl}${pprId}`);
}
